import { describeQuotas } from "../api";
import type { DescribeQuotasResponse } from "../api/types";
import { toValue, type MaybeRefOrGetter } from "vue";

type QuotaList = DescribeQuotasResponse["QuotaList"];

export const kceQuotasOptions = (region: MaybeRefOrGetter<string>) => ({
  queryKey: ["describeQuotas", region],
  queryFn: async (): Promise<QuotaList> => {
    const r = toValue(region);
    const res = await describeQuotas({
      Region: r,
      QuotaNames: [
        __CLUSTER_SIZE_QUOTA_NAME__,
        __MANAGED_CLUSTER_SIZE_QUOTA_NAME__,
        __QUOTA_NODEPOOL_MAX_NODE_NAME__,
      ],
    });
    return res.data.Data.QuotaList;
  },
});

export const vpcQuotasOptions = (region: MaybeRefOrGetter<string>) => ({
  queryKey: ["describeQuotas", region, { ServiceId: Number(__QUOTA_VPC_SERVICE_ID__) }],
  queryFn: async (): Promise<QuotaList> => {
    const r = toValue(region);
    const res = await describeQuotas({
      Region: r,
      ServiceId: Number(__QUOTA_VPC_SERVICE_ID__),
      QuotaNames: [__QUOTA_VPC_ROUTE_NAME__],
    });
    return res.data.Data.QuotaList;
  },
});

export const cidrCustomQuotasOptions = (region: MaybeRefOrGetter<string>) => ({
  queryKey: ["describeQuotas", region, { QuotaNames: [__QUOTA_KCE_V2_CIDR_CUSTOM_NAME__] }],
  queryFn: async (): Promise<QuotaList> => {
    const r = toValue(region);
    const res = await describeQuotas({
      Region: r,
      QuotaNames: [__QUOTA_KCE_V2_CIDR_CUSTOM_NAME__],
    });
    return res.data.Data.QuotaList;
  },
  select: (list: QuotaList) => list?.find(q => q.Name === __QUOTA_KCE_V2_CIDR_CUSTOM_NAME__)?.Max ?? 0,
});
